import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { alertError, toastInfo, confirm } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import { closeChannel } from "actions/ui";
import { removeChannel } from "actions/application";

class ChannelRemove extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.handleRemove = this.handleRemove.bind(this);
	}

	handleRemove(e) {
		e.preventDefault();
		e.stopPropagation();

		if (this.props.channel.type === 'private') {
			this.props.confirm(this.props.i18n.askChannelRemoveAndQuit, null, () => {}, [
				{ text: this.props.i18n.removeFromList, callback: () => this.props.sendUserCommand('removeUserChannel', 'removeUserChannel', { channelId: this.props.channel.id }) },
				{ text: this.props.i18n.quitMembership, callback: () => this.props.sendUserCommand('quitMembership', 'quitMembership', { channelId: this.props.channel.id }) },
				{ text: this.props.i18n.cancel, callback: () => {} }
			].filter( button => button ), {
				buttonYes: { hidden: true },
				buttonNo: { hidden: true }
			});
		} else {
			this.props.confirm(this.props.i18n.askChannelRemove, null, () => {}, [
				{ text: this.props.i18n.removeFromList, callback: () => this.props.sendUserCommand('removeUserChannel', 'removeUserChannel', { channelId: this.props.channel.id }) },
				{ text: this.props.i18n.cancel, callback: () => {} }
			].filter( button => button ), {
				buttonYes: { hidden: true },
				buttonNo: { hidden: true }
			});
		}
	}

	componentDidUpdate(prevProps) {
		const removalFailure = this.props.removeUserChannel !== prevProps.removeUserChannel && this.props.removeUserChannel && this.props.removeUserChannel.success === false;
		const removed = this.props.removeUserChannel !== prevProps.removeUserChannel && this.props.removeUserChannel && this.props.removeUserChannel.success === true;
		const quitFailure = this.props.quitMembership !== prevProps.quitMembership && this.props.quitMembership && this.props.quitMembership.success === false;
		const quit = this.props.quitMembership !== prevProps.quitMembership && this.props.quitMembership && this.props.quitMembership.success === true;
		const appliedToThisChannel = this.props.removeUserChannel?.result?.parameters.channelId === this.props.channel.id;
		const quiteAppliedToThisChannel = this.props.quitMembership?.result?.parameters.channelId === this.props.channel.id;

		if (removalFailure) {
			this.props.alertError(this.props.removeUserChannel.error);
			this.props.clearUserCommand('removeUserChannel');
		}
		if (quitFailure) {
			this.props.alertError(this.props.quitMembership.error);
			this.props.clearUserCommand('quitMembership');
		}

		if (removed && appliedToThisChannel) {
			this.props.clearUserCommand('removeUserChannel');
			this.props.closeChannel(this.props.channel.id);
			this.props.removeChannel(this.props.channel.id);
			this.props.toastInfo(this.props.i18n.channelRemovedFromList);
		}
		if (quit && quiteAppliedToThisChannel) {
			this.props.clearUserCommand('quitMembership');
			this.props.closeChannel(this.props.channel.id);
			this.props.removeChannel(this.props.channel.id);
			this.props.toastInfo(this.props.i18n.channelUnsubscribe);
		}
	}

	render() {
		if (!this.props.channel.canRemove) {
			return null;
		}

		return <span className="wcChannelEditButton wcIcon wcIconTimes" title={ this.props.i18n.removeChannel } onClick={ this.handleRemove } />;
	}

}

ChannelRemove.propTypes = {
	channel: PropTypes.object.isRequired,
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18nBase: state.configuration.i18n,
		i18n: state.application.i18n,
		removeUserChannel: state.commands.sent.removeUserChannel,
		quitMembership: state.commands.sent.quitMembership
	}),
	{ sendUserCommand, clearUserCommand, alertError, confirm, closeChannel, removeChannel, toastInfo }
)(ChannelRemove);